// extracted by mini-css-extract-plugin
export default {"selected":"_670860a76e","un":"_45b2366380"};